import { render, staticRenderFns } from "./labelSelect.vue?vue&type=template&id=3718f1e2&scoped=true&"
import script from "./labelSelect.vue?vue&type=script&lang=js&"
export * from "./labelSelect.vue?vue&type=script&lang=js&"
import style0 from "./labelSelect.vue?vue&type=style&index=0&id=3718f1e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3718f1e2",
  null
  
)

component.options.__file = "labelSelect.vue"
export default component.exports